import paths from "@icarius-router/paths";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.historicAccumulators],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "employeeCode",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.historicAccumulators],
        config: {
            headerName: getLocalizedString("namesAndLastnames"),
            field: "employeeName",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.historicAccumulators],
        config: {
            headerName: getLocalizedString("processPeriod"),
            field: "period",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.historicAccumulators],
        config: {
            headerName: getLocalizedString("accumulatorCode"),
            field: "accumulatorCode",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.historicAccumulators],
        config: {
            headerName: getLocalizedString("accumulatorName"),
            field: "accumulatorName",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.historicAccumulators],
        config: {
            headerName: getLocalizedString("employeesProcessAmount"),
            field: "quantity",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.historicAccumulators],
        config: {
            headerName: getLocalizedString("employeesProcessPorcentaje"),
            field: "percentage",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.historicAccumulators],
        config: {
            headerName: getLocalizedString("amount"),
            field: "amount",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
]